import React from 'react'

const Dashboard = () => {
  return (
    <div className='w-full h-full flex items-center justify-center'>
      <h1 className='w-full h-full flex items-center justify-center'>
      Coming Soon...
      </h1>
    </div>
  )
}

export default Dashboard
